import React from 'react';
import { LuFolderOpen } from 'react-icons/lu';
import { cx } from '../../utils/cx.js';
import IconChip from './IconChip';

/** Insights empty state: tinted icon, title, one-line explanation, optional action. */
const EmptyState = ({
  icon = LuFolderOpen,
  tone = 'brand',
  title,
  description = null,
  action = null,
  bordered = false,
  className = '',
}) => (
  <div
    className={cx(
      'flex flex-col items-center justify-center px-6 py-12 text-center',
      bordered && 'rounded-xl border border-gray-200 bg-white dark:border-gray-900 dark:bg-night-800',
      className,
    )}
  >
    <IconChip icon={icon} tone={tone} size="lg" className="mb-4" />
    <h2 className="mb-1 text-base font-semibold text-gray-900 dark:text-white">{title}</h2>
    {description && <p className="max-w-sm text-sm text-gray-500 dark:text-gray-400">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
